// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"83158588","213":"219041c8","239":"8345e50b","557":"040882f4","732":"35b8cabd","762":"58feebd7"}[chunkId] + ".chunk.js";
};